/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { DisconnectOutlined } from '@ant-design/icons';
import TitleWithText from '@components/TitleWithText';
import { MIDDLE_STYLE } from '@constants/responsive';
import { useAppDispatch, useAuthState, useBusinessState } from '@core/configureStore';
import { fetchJobberInfo } from '@core/features/business/thunks/fetchJobberInfo.thunk';
import { heroApiService } from '@services/service-register';

type Props = {};

const ConnectJobberIntegrationButton = (props: Props) => {
  const { user } = useAuthState();
  const dispatch = useAppDispatch();
  const { integration } = useBusinessState();
  const [loading, setLoading] = useState<boolean>(false);
  const [mount, setMount] = useState<boolean>(false);
  const handleConnect = async () => {
    if (!user) return;

    const rootUrl = `https://api.getjobber.com/api/oauth/authorize`;
    const options = {
      redirect_uri: process.env.REACT_APP_JOBBER_CALLBACK_URL as string,
      client_id: process.env.REACT_APP_JOBBER_APPLICATION_ID as string,
      response_type: 'code',
      state: user.google_sub as unknown as string,
    };

    const qs = new URLSearchParams(options);
    window.open(`${rootUrl}?${qs.toString()}`);
  };

  const handleRefresh = async () => {
    if (!user) return;

    try {
      await dispatch(fetchJobberInfo());
    } catch (error) {
      console.log(error);
    }
  };

  const handleLogoutJobber = async () => {
    if (!user) return;
    setLoading(true);
    try {
      await heroApiService.unintegrateJobberFromLocation();
      await handleRefresh();
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      setMount(false);
      await handleRefresh();
      setMount(true);
      setLoading(false);
    };
    init();
  }, []);

  return mount && integration.jobber ? (
    <div
      style={{
        ...MIDDLE_STYLE,
        flexWrap: 'wrap',
        flexDirection: 'column',
      }}>
      <TitleWithText title="Connected Account">{integration.jobber}</TitleWithText>
      <br />
      <Button icon={<DisconnectOutlined />} onClick={handleLogoutJobber}>
        Disconnect Jobber Integration
      </Button>
    </div>
  ) : (
    <Button loading={loading} onClick={handleConnect} style={{ ...MIDDLE_STYLE }}>
      <img alt="Jobber" src="jobber.png" width={25} height={25} style={{ marginRight: 10 }} />{' '}
      Connect to Jobber
    </Button>
  );
};

export default ConnectJobberIntegrationButton;
